<template>
  <b-container v-if="!loading" class="d-flex flex-column mh-100" fluid>
    <div ref="scroll" v-bar class="mt-2">
      <div>
        <b-row class="row">
          <b-col sm="6">
            <b-card class="mb-4" no-body>
              <b-card-body>
                <b-card-title>
                  <b-icon icon="layers" />
                  Intervalové dáta:
                  <span class="font-weight-normal"
                    >Západoslovenská distribučná</span
                  >
                </b-card-title>
                <b-media>
                  <template #aside>
                    <img
                      class="img-fluid mr-5"
                      src="/images/zsd.png"
                      style="max-width: 150px"
                    />
                  </template>
                  <div class="fs-lg">Pripojené odberné miesta</div>
                  <div class="h3 mt-0">
                    <span class="text-success">{{ energy.zse.count }}</span>
                    / {{ energy.zse.total }}
                  </div>
                </b-media>
                <hr />
                <div class="row form-group mb-1">
                  <label class="col-sm-4 col-form-label">
                    <b-icon icon="globe" />
                    API URL
                  </label>
                  <div class="col-sm-8">
                    <div class="form-control-plaintext">
                      https://energydata.api.e-sm.eu/v1/electricity/zse/
                    </div>
                  </div>
                </div>
                <div class="row form-group mb-1">
                  <label class="col-sm-4 col-form-label">
                    <b-icon icon="clock" />
                    Interval stiahnutia dát
                  </label>
                  <div class="col-sm-8">
                    <div class="form-control-plaintext">denne</div>
                  </div>
                </div>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col sm="6">
            <b-card class="mb-4" no-body>
              <b-card-body>
                <b-card-title>
                  <b-icon icon="layers" />
                  Intervalové dáta:
                  <span class="font-weight-normal"
                    >Stredoslovenská distribučná</span
                  >
                </b-card-title>
                <b-media>
                  <template #aside>
                    <img
                      class="img-fluid mr-5"
                      src="/images/ssd.png"
                      style="max-width: 150px"
                    />
                  </template>
                  <div class="fs-lg">Pripojené odberné miesta</div>
                  <div class="h3 mt-0">
                    <span class="text-success">{{ energy.sse.count }}</span>
                    / {{ energy.sse.total }}
                  </div>
                </b-media>
                <hr />
                <div class="row form-group mb-1">
                  <label class="col-sm-4 col-form-label">
                    <b-icon icon="globe" />
                    API URL
                  </label>
                  <div class="col-sm-8">
                    <div class="form-control-plaintext">
                      https://energydata.api.e-sm.eu/v1/electricity/sse/
                    </div>
                  </div>
                </div>
                <div class="row form-group mb-1">
                  <label class="col-sm-4 col-form-label">
                    <b-icon icon="clock" />
                    Interval stiahnutia dát
                  </label>
                  <div class="col-sm-8">
                    <div class="form-control-plaintext">denne</div>
                  </div>
                </div>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6">
            <b-card class="mb-4" no-body>
              <b-card-body>
                <b-card-title>
                  <b-icon icon="layers" />
                  Intervalové dáta:
                  <span class="font-weight-normal"
                    >Východoslovenská distribučná</span
                  >
                </b-card-title>
                <b-media>
                  <template #aside>
                    <img
                      class="img-fluid mr-5"
                      src="/images/vsd.png"
                      style="max-width: 150px"
                    />
                  </template>
                  <div class="fs-lg">Pripojené odberné miesta</div>
                  <div class="h3 mt-0">
                    <span class="text-success">{{ energy.vse.count }}</span>
                    / {{ energy.vse.total }}
                  </div>
                </b-media>
                <hr />
                <div class="row form-group mb-1">
                  <label class="col-sm-4 col-form-label">
                    <b-icon icon="globe" />
                    API URL
                  </label>
                  <div class="col-sm-8">
                    <div class="form-control-plaintext">
                      https://energydata.api.e-sm.eu/v1/electricity/vse/
                    </div>
                  </div>
                </div>
                <div class="row form-group mb-1">
                  <label class="col-sm-4 col-form-label">
                    <b-icon icon="clock" />
                    Interval stiahnutia dát
                  </label>
                  <div class="col-sm-8">
                    <div class="form-control-plaintext">denne</div>
                  </div>
                </div>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col sm="6">
            <b-card class="mb-4" no-body>
              <b-card-body>
                <b-card-title>
                  <b-icon icon="layers" />
                  Intervalové dáta:
                  <span class="font-weight-normal">SPP distribúcia</span>
                </b-card-title>
                <b-media>
                  <template #aside>
                    <img
                      class="img-fluid mr-5"
                      src="/images/spp.png"
                      style="max-width: 150px"
                    />
                  </template>
                  <div class="fs-lg">Pripojené odberné miesta</div>
                  <div class="h3 mt-0">
                    <span class="text-success">{{ energy.spp.count }}</span>
                    / {{ energy.spp.total }}
                  </div>
                </b-media>
                <hr />
                <div class="row form-group mb-1">
                  <label class="col-sm-4 col-form-label">
                    <b-icon icon="globe" />
                    API URL
                  </label>
                  <div class="col-sm-8">
                    <div class="form-control-plaintext">
                      https://energydata.api.e-sm.eu/v1/gas/spp/
                    </div>
                  </div>
                </div>
                <div class="row form-group mb-1">
                  <label class="col-sm-4 col-form-label">
                    <b-icon icon="clock" />
                    Interval stiahnutia dát
                  </label>
                  <div class="col-sm-8">
                    <div class="form-control-plaintext">denne</div>
                  </div>
                </div>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </div>
  </b-container>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      energy: {},
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData(silent = false) {
      this.loading = !silent
      this.$api.get('energy_data/get_subscribed').then((res) => {
        this.energy.zse = res.data.zse
        this.energy.sse = res.data.sse
        this.energy.vse = res.data.vse
        this.energy.spp = res.data.spp
        if (!silent) {
          this.loading = false
        }
      })
    },
  },
}
</script>
